define((require) => {
    "use strict";

    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const LoggedIn = require("shared/security/LoggedIn");
    const Configuration = require("shared/services/Configuration");

    const MatomoReportingModel = ImprovedModel.extend("MatomoReporting", {

    /**
     * This is sending a call to Matomo for Reporting.
     * We send the bearer token to the Matomo auth wrapper
     * with the users companyID and username
     * in order to Authenticate.
     *
     * Matomo returns either a error if the Authentication is wrong
     * or an html snippet if the Authentication is correct.
     */
        getMatomoRedirect() {
            const url = Configuration.matomoConfig.dashboardUrl;
            const urloptions = {
                method: "post",
                type: "POST",
                url,
                data: {
                    /**
                     * We don't add the Bearer token because it's added on the Ajax prefilter.
                     * The token on the principal is not correct.
                     * See Login.js
                     */
                    companyId: LoggedIn.principal().get("companyId"),
                    email: LoggedIn.principal().get("user.username")
                },
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
            };

            return this.fetch(urloptions);
        },

        // if you just have a single experience the second will be null, thats ok
        // if you have breakpoints you'll have a group_id and experience ids delimited by ::
        // 488929321039::23823902389032::20832903289 so you can build the right segment
        createNewSegment(experienceID, experienceGroupID, experienceGroupName) {
            const url = Configuration.matomoConfig.segmentUrl;

            const urloptions = {
                method: "get",
                type: "GET",
                url,
                data: {
                    clientId: LoggedIn.principal().get("companyId"),
                    experienceId: experienceID,
                    experienceGroupId: experienceGroupID,
                    experienceGroupName: experienceGroupName
                }
            };

            return this.fetch(urloptions);
        },

        redirectToSegmentPage(segment) {
            const url = Configuration.matomoConfig.dashboardUrl;
            const urloptions = {
                method: "post",
                type: "POST",
                url,
                data: {
                    /**
                     * We don't add the Bearer token because it's added on the Ajax prefilter.
                     * The token on the principal is not correct.
                     * See Login.js
                     */
                    companyId: LoggedIn.principal().get("companyId"),
                    email: LoggedIn.principal().get("user.username"),
                    segment: segment
                },
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
            };

            return this.fetch(urloptions);
        }

    });
    return MatomoReportingModel;
});



// WEBPACK FOOTER //
// ./src/editor/ui/reporting/MatomoReportingModel.js